import { getRum } from "../../aws-app-monitor/rum";

export const loginRumTracker = () => {
  /*
    CloudWatch RUM – Active User Tracking
    Tracks user logins to analyze user interactions in CloudWatch dashboards.
  */
  const rum = getRum();
  if (!rum) return;

  const token = localStorage.getItem("JMLAuthToken");
  const userId = localStorage.getItem("userId");

  if (token && token !== "" && userId && userId !== "") {
    rum.recordEvent("active_user_logged_in", {
      user_id: userId,
    });
  }
};

export const logoutRumTracker = () => {
  /*
    CloudWatch RUM – Active User Tracking
    Tracks user logouts to analyze user interactions in CloudWatch dashboards.
  */
  const rum = getRum();
  if (!rum) return;

  const token = localStorage.getItem("JMLAuthToken");
  const userId = localStorage.getItem("userId");

  if (token && token !== "" && userId && userId !== "") {
    rum.recordEvent("active_user_logged_out", {
      user_id: userId,
    });
  }
};
